import Axios from 'axios';
 
const BANK = '/bank';
const BANK_DEPOSIT = '/bank_deposit';
const BANK_DEPOSIT_TRANSACTION='/bank_deposit_transaction'

export default {

  //BANK
  getAllBanks() {
    return Axios.get(BANK);
  },
 
  getBank(id) {
    return Axios.get(`${BANK}/${id}`);
  },
 
  createBank(data) {
    return Axios.post(BANK, data);
  },
 
  updateBank(id, data) {
    return Axios.put(`${BANK}/${id}`, data);
  },
 
  deleteBank(id) {
    return Axios.delete(`${BANK}/${id}`);
  },
 
  getUserBank(user_external_id){
    return Axios.get(`${BANK}/getByUser/${user_external_id}`);
  },


  //BANK_DEPOSIT
  getAllBankDeposits() {
    return Axios.get(BANK_DEPOSIT);
  },
 
  getBankDeposit(id) {
    return Axios.get(`${BANK_DEPOSIT}/${id}`);
  },
 
  createBankDeposit(data) {
    return Axios.post(BANK_DEPOSIT, data);
  },
 
  updateBankDeposit(id, data) {
    return Axios.put(`${BANK_DEPOSIT}/${id}`, data);
  },
 
  deleteBankDeposit(id) {
    return Axios.delete(`${BANK_DEPOSIT}/${id}`);
  },
 
  getDepositsByBank(bank_external_id){
    return Axios.get(`${BANK_DEPOSIT}/getByBank/${bank_external_id}`);
  },

  
  //BANK_DEPOSIT TRANSACTIONS
  getAllBankDepositTransactions() {
    return Axios.get(BANK_DEPOSIT_TRANSACTION);
  },
 
  getBankDepositTransaction(id) {
    return Axios.get(`${BANK_DEPOSIT_TRANSACTION}/${id}`);
  },
 
  createBankDepositTransaction(data) {
    return Axios.post(BANK_DEPOSIT_TRANSACTION, data);
  },
 
  updateBankDepositTransaction(id, data) {
    return Axios.put(`${BANK_DEPOSIT_TRANSACTION}/${id}`, data);
  },
 
  deleteBankDepositTransaction(id) {
    return Axios.delete(`${BANK_DEPOSIT_TRANSACTION}/${id}`);
  },
 
  getTransactionsByDeposit(deposit_external_id){
    return Axios.get(`${BANK_DEPOSIT_TRANSACTION}/getByDeposit/${deposit_external_id}`);
  },

  deleteTransactionsByDeposit(deposit_external_id) {
    return Axios.delete(`${BANK_DEPOSIT_TRANSACTION}/deleteByDeposit/${deposit_external_id}`);
  },

  bulkCreateBankDepositTransaction(data) {
    return Axios.post(`${BANK_DEPOSIT_TRANSACTION}/bulkCreate`, data);
  },
}